import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useRegions = () => {
  const urlStr = `${getApiUrl()}/region`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useRegion = (id) => {
  const urlStr = `${getApiUrl()}/region/${id}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePostRegion = () => {
  const postRegion = async (payload) => {
    try {
      const url = `${getApiUrl()}/admin/region`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postRegion;
};

export const usePutRegion = () => {
  const postRegion = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/admin/region/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postRegion;
};

export const useDeleteRegion = () => {
  const deleteRegion = async (id) => {
    try {
      const url = `${getApiUrl()}/admin/region/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteRegion;
};
